import { NotificationsActive, NotificationsNone } from "@mui/icons-material";
import { Box, Button, Tooltip } from "@mui/material";
import { useCurrentUser } from "../../../App/Queries/UserQueries";

export const ToggleNotificationAlerts = ({
  isMultiMessage = false,
  notifyMe = false,
  disableNotificationToggle = true,
  setNotifyMe,
}: {
  isMultiMessage?: boolean;
  notifyMe: boolean;
  disableNotificationToggle: boolean;
  setNotifyMe?: (value: boolean) => void;
}) => {
  const { email } = useCurrentUser();
  let subject = isMultiMessage ? "any of these messages are" : "this message is";
  let message = `Notify me at ${email} when ${subject} replied to. You can set your default preference on the Profile page.`;
  if (disableNotificationToggle === true) {
    message = `You have opted in to receive alerts at ${email} when ${subject} replied to.`;
  } else if (notifyMe) {
    message = `You will be notified at ${email} when ${subject} replied to. Click to disable notifications. You can set your default preference on the Profile page.`;
  }
  return (
    <Tooltip data-test="toggle-notification-alerts" title={message} arrow>
      <Box>
        <Button
          variant={notifyMe ? "contained" : "outlined"}
          color="info"
          sx={{ minWidth: "40px", minHeight: "40px", margin: 0 }}
          disabled={disableNotificationToggle === true}
          onClick={() => {
            if (!disableNotificationToggle && setNotifyMe) {
              setNotifyMe(!notifyMe);
            }
          }}
        >
          {notifyMe || !disableNotificationToggle ? (
            <NotificationsActive fontSize="small" />
          ) : (
            <NotificationsNone fontSize="small" />
          )}
        </Button>
      </Box>
    </Tooltip>
  );
};
